import { Link } from "react-router-dom";

const Terms = () => (
  <>
    {/* Page Title Section */}
    <div className="wd-page-title page-title page-title-default title-size-default title-design-centered color-scheme-light">
      <div className="container">
        <h1 className="entry-title title">Terms</h1>
        <nav className="wd-breadcrumbs">
          <span typeof="v:Breadcrumb">
            <Link to="/" rel="v:url" property="v:title">
              Home
            </Link>
          </span>
          <span className="wd-delimiter"></span>
          <span className="wd-last">Terms</span>
        </nav>
      </div>
    </div>
    {/* Main Content Area for Privacy Policy */}
    <div className="wd-page-content main-page-wrapper">
      <h1 style={{ textAlign: "center", margin: "2rem" }}>
        Terms
        <hr />
      </h1>
      <main
        className="wd-content-layout content-layout-wrapper container"
        role="main"
      >
        These Terms of Use govern your access to and use of our website and
        services, outlining your rights, responsibilities, and obligations as a
        user. By accessing or using the website of Virtual Wallet Systems Pvt
        Ltd, located at Noida Sec 63, you agree to comply with these terms and
        conditions. If you do not agree with any part of these terms, please
        discontinue use of the website immediately. The Terms and Conditions,
        along with our Privacy Policy and Disclaimer Notice, apply to all users
        of the site. In this context, terms such as "Client," "You," and "Your"
        refer to you, the user accessing the website in agreement with the
        Company’s terms. "The Company," "We," "Our," and "Us" refer to Virtual
        Wallet Systems Pvt Ltd. The terms "Party," "Parties," or "Us" refer
        collectively to both you (the Client) and the Company. All references in
        these documents relate to the offering, acceptance, and consideration of
        payment necessary to provide services to the Client in the most
        appropriate manner, with the aim of fulfilling the Client’s needs as
        stated by the Company. These terms are governed by and interpreted in
        accordance with the prevailing laws of the India. Any use of the above
        terminology—whether singular or plural, capitalized or not, and whether
        referring to he, she, or they—shall be interpreted as interchangeable
        and equivalent.
        <hr style={{ border: "2px solid #9D0FA4" }} />
      </main>
    </div>
  </>
);

export default Terms;
